import Button, { ButtonProps } from '@/src/components/atom/Button';

import { BUTTON_CONST } from '@/src/constants/buttons';
import { ReactComponent as IconExcel } from '@/assets/icons/icon-excel.svg';
import { cn } from '@/src/utils';
import ExcelPasswordDialog from '@/src/components/organism/ExcelPasswordDialog/ExcelPasswordDialog';
import { useState } from 'react';
import { downloadBlob } from '@/src/utils/downloadFile';
import { toast } from '@/src/hooks/useToast';

interface Props extends Omit<ButtonProps, 'children'> {
  searchParams?: any;
  downloadExcelAPI: (password: string, searchParams?: any) => Promise<Blob>;
  fileName: string;
  buttonText?: string;
}

const renderIconSize = (buttonSize: ButtonProps['buttonSize']) => {
  switch (buttonSize) {
    case 'xSmall':
    case 'small':
    case 'medium':
    case 'large':
    default:
      return 20;
  }
};

export default function ExcelDownloadButton({
  className,
  buttonSize = 'medium',
  searchParams,
  downloadExcelAPI,
  fileName,
  buttonText,
  ...rest
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const handleExcelDownload = async (password: string) => {
    if (!downloadExcelAPI) return;

    try {
      const blob = await downloadExcelAPI(password, searchParams);
      downloadBlob({ blob, fileName: fileName || '엑셀 다운로드' });
    } catch (e: any) {
      toast({
        variant: 'error',
        title: 'Error',
        description: e?.response?.data?.message || e?.message,
      });
    }
  };

  return (
    <>
      <Button
        className={cn(
          'flex gap-2',
          rest.disabled ? 'disabled:opacity-50' : '',
          className,
        )}
        buttonSize={buttonSize}
        buttonColor="green"
        {...rest}
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <IconExcel
          width={renderIconSize(buttonSize)}
          height={renderIconSize(buttonSize)}
        />
        <div className="flex items-center gap-x-2">
          {buttonText || BUTTON_CONST.downloadExcel}
        </div>
      </Button>

      {/* 모달 */}
      <ExcelPasswordDialog
        isOpen={isOpen}
        setOpen={setIsOpen}
        submitCallback={handleExcelDownload}
      />
    </>
  );
}
